module.exports = __webpack_public_path__ + "static/media/google-play-badge.db9b21a1.png";